<template>
    <div id="header"
         :class="data.classHeader"
    >
        <div id="header-left">
            <a id="btn-thumb-view"
                 class="btn-main-func"
                 href="#"
                 v-show="booklistState.viewMode==='thumb'"
                :title="i18n.t('tooltip_list_view')"
                 @click.prevent="booklistState.viewMode='list'"
            >
                <img src="~images/btn_booklist.png">
            </a>
            <a id="btn-list-view"
                 class="btn-main-func"
                 href="#"
                 v-show="booklistState.viewMode==='list'"
                 :title="i18n.t('tooltip_thumbnail_view')"
                 @click.prevent="booklistState.viewMode='thumb'"
            >
                <img src="~images/btn_bookthumb.png">
            </a>
            <drop-down :data-provider="data.subjectProvider"
                       :defaultLabel="'label_all_subject'"
                       :dropdownHeight="'36px'"
                       :listWidth="'200px'"
                       :id="'dropdown-subject'"
                       @item-selected="onSubjectChanged"
                       ref="refDropDownSubject"
            >
            </drop-down>

            <drop-down :data-provider="data.categoryProvider"
                       :defaultLabel="'label_all_category'"
                       :dropdownHeight="'36px'"
                       :listWidth="'200px'"
                       :id="'dropdown-category'"
                       @item-selected="onTypeChanged"
                       ref="refDropDownType"
            >
            </drop-down>
        </div>
        <div id="header-right">
            <img :src="data.avatar">
            <span class="member-name">{{ data.memberName }}</span>
        </div>
    </div>
</template>

<script>

    import {ref, reactive, onMounted, onUpdated, watchEffect, computed, nextTick, inject}  from "vue"
    import DropDown from "@/views/lib/dropdown/DropDown";
    import config from "@/config/config.json";
    import {useBookInfo} from "@/modules/reader/book/bookinfo";
    import {useBookList} from "@/modules/home/booklist";
    import {uniqueArrayOfObjectByKey} from "@/modules/utils/arrayUtils";
    import SimpleList from "@/views/lib/listing/SimpleList";
    import {isTouchDevice} from "@/modules/utils/deviceUtils";

    export default {
        components:{
          DropDown,
          SimpleList
        },
        setup(props, context) {

            const { booklistState} = useBookList();
            const i18n = inject('i18n');

            const data = reactive({
                memberName:JSON.parse(localStorage.name).zh,
                avatar: localStorage.avatar,
                subjectProvider: [],
                categoryProvider:[],
                ebooklist: computed(()=>{
                    return JSON.parse(localStorage.ebooklist);
                }),
                classHeader:computed(()=>{
                    return {
                        "no-touch": !isTouchDevice()
                    }
                })
            });

            const refDropDownSubject = ref(null);
            const refDropDownType = ref(null);

            const populateFilterItems = ()=> {

                let subjectList = [];
                let categoryList = [];

                for (let book of data.ebooklist) {
                    let subjectcode = book["subjectcode"];
                    let subjectname = book["subjectname"]
                    let ebooktypecode = book["ebooktypecode"];
                    let ebooktypename = book["ebooktypename"];

                    subjectList.push({
                        label: {
                            zh:subjectname.zh,
                            en:subjectname.en
                        },
                        value: subjectcode
                    })

                    categoryList.push({
                        label: {
                            zh:ebooktypename.zh,
                            en:ebooktypename.en
                        },
                        value: ebooktypecode
                    })
                }

                data.subjectProvider = uniqueArrayOfObjectByKey(subjectList, "value");
                data.categoryProvider = uniqueArrayOfObjectByKey(categoryList, "value")

                nextTick(()=> {
                    refDropDownSubject.value.setCurrentItem(booklistState.filteredSubjectCode);
                    refDropDownType.value.setCurrentItem(booklistState.filteredTypeCode);
                });


            }


            const onSubjectChanged = (item)=>{
                console.log("selected item:");
                console.log(item)
                booklistState.filteredSubjectCode = item.value;
            }

            const onTypeChanged = (item)=>{
                console.log("selected item:");
                console.log(item)
                booklistState.filteredTypeCode = item.value;
            }

            onMounted(()=>{
                populateFilterItems();
                //if directly go to reader page from sso, then go back to home, the previous logged in member name may not be able to refresh ,
                //so every time home header is rendered, update the member name and avatar
                data.membername = JSON.parse(localStorage.name).zh;
                data.avatar = localStorage.avatar;
            })

            return {
                data,
                i18n,
                refDropDownSubject,
                refDropDownType,
                booklistState,
                onSubjectChanged,
                onTypeChanged
            }
        }
    }
</script>

<style scoped lang="scss">

    #header {
        text-shadow:$header-text-shadow;
    }

    #header-right {
        color:#fff;

        img {
            width:$btn-main-func-size;
            height:$btn-main-func-size;
            border-radius:4px;
            margin:0 6px;
        }

        .member-name {
            margin:0 5px;
        }
    }

    .dropdown {
        margin:0 20px 0 0;
    }

</style>